<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>夺宝礼品</span>
        </div>

        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="普通" name="default">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData.default" :key="index">
                <el-form-item label="奖品ID">
                  <el-input v-model.number="item.id" readonly style="width: 100px;" placeholder="奖品ID" />
                </el-form-item>
                <el-form-item label="奖品大类">
                  <el-select v-model="item.reward.type" placeholder="请选择" @change="(v)=>{return getRewardList(v, 'default',index)}">
                    <el-option
                      v-for="item in cateType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="奖品ID">
                  <el-select v-model="item.reward.id" placeholder="请选择">
                    <el-option
                      v-for="item in options['default'][index]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="奖品数量">
                  <el-input v-model.number="item.reward.num" style="width: 100px;" placeholder="奖品数量" />
                </el-form-item>
                <el-form-item label="排序">
                  <el-input v-model.number="item.sort" style="width: 100px;" placeholder="奖品数量" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:luckDraw:del']" type="danger" @click="del(item.id,index,'default')">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:luckDraw:add']" type="primary" @click="add('default')">+</el-button>
              </el-form-item>
              <el-button v-permisaction="['config:luckDraw:add']" type="primary" @click="onSubmit('default')">保存</el-button>
            </el-form>

            <pagination
              v-show="totalObj.default.total>0"
              background
              :page.sync="queryParams.default.pageIndex"
              :limit.sync="queryParams.default.pageSize"
              :total="totalObj.default.total"
              @pagination="getTables"
            />
          </el-tab-pane>
          <el-tab-pane label="vip" name="vip">
            <el-form :inline="true" class="demo-form-inline">
              <el-row v-for="(item, index) in formData.vip" :key="index">
                <el-form-item label="奖品ID">
                  <el-input v-model.number="item.id" readonly style="width: 100px;" placeholder="奖品ID" />
                </el-form-item>
                <el-form-item label="奖品大类">
                  <el-select v-model="item.reward.type" placeholder="请选择" @change="(v)=>{return getRewardList(v, 'vip',index)}">
                    <el-option
                      v-for="item in cateType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="奖品ID">
                  <el-select v-model="item.reward.id" placeholder="请选择">
                    <el-option
                      v-for="item in options['default'][index]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="奖品数量">
                  <el-input v-model.number="item.reward.num" style="width: 100px;" placeholder="奖品数量" />
                </el-form-item>
                <el-form-item label="排序">
                  <el-input v-model.number="item.sort" style="width: 100px;" placeholder="奖品数量" />
                </el-form-item>
                <el-form-item>
                  <el-button v-permisaction="['config:luckDraw:del']" type="danger" @click="del(item.id,index,'vip')">删除</el-button>
                </el-form-item>
              </el-row>
              <el-form-item>
                <el-button v-permisaction="['config:luckDraw:add']" type="primary" @click="add('vip')">+</el-button>
              </el-form-item>
              <el-button v-permisaction="['config:luckDraw:add']" type="primary" @click="onSubmit('vip')">保存</el-button>
            </el-form>

            <pagination
              v-show="totalObj.vip.total>0"
              background
              :page.sync="queryParams.vip.pageIndex"
              :limit.sync="queryParams.vip.pageSize"
              :total="totalObj.vip.total"
              @pagination="getTables"
            />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCateList, getRewardType, updateLuckyDraw, getLuckyDrawList, delLuckyDraw } from '@/api/config/lucky-draw'
export default {
  name: 'LuckyDraw',
  data() {
    return {
      activeName: 'default',
      totalObj: {
        default: {
          total: 0
        },
        vip: {
          total: 0
        }
      },
      queryParams: {
        default: {
          pageIndex: 1,
          pageSize: 10,
          isVip: 0
        },
        vip: {
          pageIndex: 1,
          pageSize: 10,
          isVip: 1
        }
      },
      cateType: [],
      options: {
        'default': [],
        'vip': []
      },
      formData: {
        'default': [{
          'id': 1,
          'is_vip': 0,
          'reward': {
            type: 1,
            id: 2,
            num: 1
          },
          'sort': 1
        }],
        'vip': [{
          'id': 1,
          'is_vip': 0,
          'reward': {
            type: 1,
            id: 2,
            num: 1
          },
          'sort': 1
        }]
      }
    }
  },
  created() {
    this.getTables('default')
    this.getCateType()
  },
  methods: {
    onSubmit(name) {
      const data = JSON.stringify(this.formData[name])
      updateLuckyDraw({ data: data, name: name }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(name)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getCateType() {
      getCateList().then(res => {
        if (res.code === 200) {
          this.cateType = res.data
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardList(v, name, index) {
      getRewardType({ id: v }).then(res => {
        if (res.code === 200) {
          // this.options[name][index] = res.data
          this.$set(this.options[name], index, res.data)
        } else {
          console.log(res.msg)
        }
      })
    },
    getTables(tableName) {
      this.formData[tableName] = []
      getLuckyDrawList(this.queryParams[tableName]).then(res => {
        this.totalObj[tableName].total = res.data.count
        res.data.list.forEach((item, index) => {
          this.getRewardList(item.reward.type, tableName, index)
        })
        this.formData[tableName] = res.data.list
      })
    },
    add(name) {
      console.log(name)
      let vip = 0
      if (name === 'vip') {
        vip = 1
      }
      this.formData[name].push({
        'id': 0,
        'is_vip': vip,
        'reward': {
          type: 1,
          id: 0,
          num: 0
        },
        'sort': 1
      })
      const index = this.formData[name].length - 1
      // this.options[index] = []
      // this.$set(this.options[name], index, [])
      this.getRewardList(1, name, index)
    },
    del(id, index, name) {
      if (id > 0) {
        this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delLuckyDraw({ id: id, data: name }).then(res => {
            if (res.code === 200) {
              this.getTables(name)
              this.msgSuccess(res.msg)
            } else {
              this.msgError(res.msg)
            }
          })
        })
      } else {
        this.formData = this.formData[name].filter((item, key) => {
          return index !== key
        })
      }
    },
    handleClick(tab) {
      console.log(tab.name)
      this.getTables(tab.name)
    }
  }
}
</script>

<style scoped>
</style>
